export default "__VITE_ASSET__CN70Jjhl__"